import React from "react";
import CardInfo from "./components/CardInfo";
import { exportChat } from "service/liveRecord";

import style from "./index.module.scss";
interface InteractionProps {
    signNum: number; //签到次数
    signRate: number; //签到参与率
    questionnaireNum: number; //发布问卷次数
    questionnaireRate: number; //发布问卷参与率
    answerCardNum: number; //答题卡次数
    answerCardRate: number; //答题卡参与率
    chatNum: number; //聊天次数
    // signNum:number; //签到次数
    channelId: string;
}
export default function Interaction({
    channelId,
    signNum,
    signRate,
    questionnaireNum,
    questionnaireRate,
    answerCardNum,
    answerCardRate,
    chatNum
}: InteractionProps) {
    const Count1 = {
        icon: require("./img/signInIcon.png"),
        name: "签到次数",
        count: signNum,
        bgColor: "#eefcff",
        ratio: signRate
    };
    const Count2 = {
        icon: require("./img/issueIcon.png"),
        name: "发布问卷",
        count: questionnaireNum,
        bgColor: "#fcf8ff",
        ratio: questionnaireRate
    };
    const Count3 = {
        icon: require("./img/answerIcon.png"),
        name: "答题卡次数",
        count: answerCardNum,
        bgColor: "#f7f7fc",
        ratio: answerCardRate
    };
    const Count4 = {
        icon: require("./img/chatIcon.png"),
        name: "聊天",
        count: chatNum,
        bgColor: "#fcf7f7"
        // ratio:80
    };

    return (
        <div className={style.interaction}>
            <CardInfo {...Count1} />
            <CardInfo {...Count2} />
            <CardInfo {...Count3} />
            <CardInfo {...Count4}>
                <img
                    className={style.down}
                    src={require("./img/down.png")}
                    alt=""
                    onClick={() => exportChat(channelId)}
                />
            </CardInfo>
        </div>
    );
}
